// extracted by mini-css-extract-plugin
export var reviewBoxLine = "cv-module--reviewBoxLine--3dGpv";
export var reviewBox_content = "cv-module--reviewBox_content--WdX3e";
export var reviewBox_title1 = "cv-module--reviewBox_title1--2gv29";
export var reviewBox_title2 = "cv-module--reviewBox_title2--3tE_9";
export var reviewBox_top = "cv-module--reviewBox_top--Tc-i7";
export var reviewBox_left = "cv-module--reviewBox_left--2ebB6";
export var reviewBox_right = "cv-module--reviewBox_right--1JUep";
export var reviewLink = "cv-module--reviewLink--2X6tA";
export var reviewBox_center = "cv-module--reviewBox_center--1NMMe";
export var score = "cv-module--score--5r7Sd";
export var score_content = "cv-module--score_content--1ixJ2";
export var score_text = "cv-module--score_text--vs8zv";
export var score_num = "cv-module--score_num--LV0Ph";
export var score_left = "cv-module--score_left--2w_fu";
export var score_line = "cv-module--score_line--2BWwJ";
export var score_line_10 = "cv-module--score_line_10--1LC4K";
export var score_line_9 = "cv-module--score_line_9--15yDX";
export var score_line_8 = "cv-module--score_line_8--1S7xl";
export var score_line_7 = "cv-module--score_line_7--UmB_A";
export var score_line_6 = "cv-module--score_line_6--3VpzZ";
export var score_line_5 = "cv-module--score_line_5--3gEFP";
export var score_line_4 = "cv-module--score_line_4--JiCik";
export var score_line_3 = "cv-module--score_line_3--3t4-U";
export var score_line_2 = "cv-module--score_line_2--c7fXf";
export var score_line_1 = "cv-module--score_line_1--ULOao";